import firebase from 'firebase'
import 'firebase/firestore'

// firebase init goes here
const config = {
  apiKey: 'AIzaSyDaTiu97ndEMHIc1z9h6jV-63hygazwOQM',
  authDomain: 'main-basis-252709.firebaseapp.com',
  databaseURL: 'https://main-basis-252709.firebaseio.com',
  projectId: 'main-basis-252709',
  storageBucket: 'main-basis-252709.appspot.com',
  messagingSenderId: '609281588049',
  appId: '1:609281588049:web:d0d832b3eacc4432c87170'
}
firebase.initializeApp(config)

// firebase utils
const db = firebase.firestore()
const auth = firebase.auth()
const currentUser = auth.currentUser

// date issue fix according to firebase
const settings = {}
db.settings(settings)

// firebase collections
const usersCollection = db.collection('users')

export { db, auth, currentUser, usersCollection }
